"use strict";

angular.module("vendor")
.service("ProductVariantsService", function($resource, $filter, $http, gettextCatalog, appConfig) {
    this.getOptions = function() {
        return $http.get(appConfig.API_SERVER + "/variants/options/");
    };

    this.getProductVariantOptionValues = function(productId) {
        return $http.get(appConfig.API_SERVER + "/variants/products/" + productId + "/variant-option-values/");
    };

    this.deleteProductVariant = function(productVariantId) {
        return $http.delete(appConfig.API_SERVER + "/variants/product-variants/" + productVariantId + "/");
    };

    this.updateProductVariant = function(productVariantId, productVariantData) {
        return $http({
            url: appConfig.API_SERVER + "/variants/product-variants/" + productVariantId + "/",
            method: "PUT",
            headers: {"Content-Type": undefined},
            data: productVariantData
        })
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/product/product-variants/product-variants.service.js
// module id = 893
// module chunks = 0